import GDPRSettingsStorage from './GDPRSettingsStorage'
import {getCookie} from "../helpers";

export default class GDPRSettingsExtension {

	constructor(naja, options = {}) {
		// moved to php, has to because of order of events
		naja.addEventListener('init', () => {
			let metaOptionsElement = document.getElementById('fn_consent_options');
			if (metaOptionsElement !== null) {
				options = Object.assign(
					options, JSON.parse(metaOptionsElement.getAttribute('data-options')));
			}

			this.options = Object.assign({
				map: {
					functional: 'functionality_storage',
					adStorage: 'ad_storage',
					adUserData: 'ad_user_data',
					adPersonalization: 'ad_personalization',
					statistics: 'analytics_storage',
				},
				testMode: false
			},
			options);
		});

		window.dataLayer = window.dataLayer || [];

		this.storage = new GDPRSettingsStorage();

		document.addEventListener('cookies-box.save', this._pushGTMEvents.bind(this))
	}

	_gtag() {
		if (this.options.testMode === false) {
			if (getCookie('debug') === '1') {
				console.log('gtag:', arguments);
			}

			window.dataLayer.push(arguments);
		} else {
			console.log('gtag:', arguments);
		}
	}

	_pushGTMEvents() {
		if (this.storage.has()) {
			const data = {};

			// GTM builtin consents
			this.storage.load().forEach((consent) => {
				if (this.options.map[consent] !== undefined) {
					data[this.options.map[consent]] = 'granted';
				}
			});

			this._gtag('consent', 'update', data);
		}
	}

}